module.exports = __webpack_public_path__ + "img/3.905fbed2.png";